<template>
  <b-modal
    :visible="visible"
    :title="title"
    hide-footer
    @hide="handleClose"
  >
    <b-form-group :label="$t('dispatcher.order-request.review.decision.comment-label')">
      <b-form-textarea
        v-model="comment"
        rows="4"
        max-rows="7"
        :disabled="loading"
      />
      <small
        v-if="validationError"
        class="text-danger"
      >
        {{ validationError }}
      </small>
    </b-form-group>

    <div class="d-flex justify-content-end gap-1">
      <b-button
        variant="outline-secondary"
        :disabled="loading"
        @click="handleClose"
      >
        {{ $t('shared.button.cancel') }}
      </b-button>
      <b-button
        variant="primary"
        :disabled="loading"
        @click="submit"
      >
        {{ confirmLabel }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton, BFormGroup, BFormTextarea, BModal,
} from 'bootstrap-vue'
import { buildDecisionPayload, hasRequiredDecisionComment } from '../helpers/reviewFormModel'

export default {
  name: 'DispatcherReviewDecisionModal',
  components: {
    BButton,
    BFormGroup,
    BFormTextarea,
    BModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    confirmLabel: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      comment: '',
      validationError: null,
    }
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        this.resetState()
      }
    },
  },
  methods: {
    submit() {
      this.validationError = null
      if (!hasRequiredDecisionComment(this.comment)) {
        this.validationError = this.$t('dispatcher.order-request.review.errors.required-comment')
        return
      }

      this.$emit('confirm', buildDecisionPayload(this.comment))
    },
    handleClose() {
      this.$emit('close')
    },
    resetState() {
      this.comment = ''
      this.validationError = null
    },
  },
}
</script>

<style scoped lang="scss">
.gap-1 {
  gap: 0.5rem;
}
</style>
